
import React, {useEffect, useState, useReducer} from "react";
import * as Reports from "../../reportStyles";
import AxlDateInput from "../../../../components/AxlDateInput";
import moment from "moment";



const getYesterday = ()=>{
    return moment().subtract(1, 'days').format("yyyy-MM-DD");
}

export const DATE_RANGE_DEFAULT = {
    dateType: 'range',
    period: null,
    fromDate: getYesterday(),
    toDate: getYesterday()
};



const DateRange = ({name,handleOnChange, currentValue}) => {


    const [fromDate, setFromDate] = useState(() => { return getYesterday()});
    const [toDate, setToDate] = useState(() => { return getYesterday()});
    const [_, forceUpdate] = useReducer((x) => x + 1, 0);

    const onChangeFromDate = (date) =>{
        if(!date){  //handle clear click
            setToDate(date && date ? moment(date).format("yyyy-MM-DD") : getYesterday())         
            if(fromDate == getYesterday() && !date){
                //force re-render as AxlInput clears value and will display placeholder
                forceUpdate();
            }
        }    
        setFromDate(date && date ? moment(date).format("yyyy-MM-DD") : getYesterday())
    }
    const onChangeToDate = (date) =>{
        setToDate(date && date ? moment(date).format("yyyy-MM-DD") : getYesterday())
        if(toDate == getYesterday() && !date){
            //force re-render as AxlInput clears value and will display placeholder
            forceUpdate();
        }     
    }
    const convertToDisplayDate = (date) => {
        return moment(date,"yyyy-MM-DD").toDate();
    }


    useEffect(()=>{
        handleOnChange(name,{
            dateType: 'range',
            fromDate: fromDate,
            toDate : toDate
        });
    },[fromDate,toDate])



    return (
        <Reports.DateRangeContainer>
            <Reports.GroupField>
                <Reports.Label>{`Report Date Range from `}</Reports.Label>
                <AxlDateInput
                    clear
                    arrow
                    onChange={(d) => onChangeFromDate(d)}
                    options={{
                        maxDate: currentValue && currentValue.toDate ? convertToDisplayDate(currentValue.toDate) : undefined,
                        defaultValue: currentValue && currentValue.fromDate ? convertToDisplayDate(currentValue.fromDate) : convertToDisplayDate(getYesterday())  ,
                        dateFormat: 'MMM DD, Y',
                        placeHolder: 'yesterday',
                        enableTime: false,
                        altInput: false,
                        clickOpens: false,
                        altInputClass: 'form-conrol'
                    }}
                />
            </Reports.GroupField>
            <Reports.GroupField>
                <Reports.Label>{`to`}</Reports.Label>
                <AxlDateInput
                    clear
                    arrow
                    onChange={(d) => onChangeToDate(d)}
                    options={{
                        minDate: currentValue && currentValue.fromDate ? convertToDisplayDate(currentValue.fromDate) : undefined,
                        defaultValue: currentValue && currentValue.toDate ? convertToDisplayDate(currentValue.toDate) : convertToDisplayDate(getYesterday()) ,
                        dateFormat: 'MMM DD, Y',
                        placeHolder: 'yesterday',
                        enableTime: false,
                        altInput: false,
                        clickOpens: false,
                        altInputClass: 'form-conrol'
                    }}
                />
            </Reports.GroupField>
        </Reports.DateRangeContainer>
    );

}


export default DateRange;